import React, { Component } from "react";

export default class ViewXeroInvoices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      xeroInvoices: [],
      customers: [],
      loading: true,
      processing: false
    };
    this.postInvoicesToXeroCustomer = this.postInvoicesToXeroCustomer.bind(this);
  }

  componentDidMount() {
    fetch("/api/v1/portal/customers/viewXeroInvoices", {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ xeroInvoices: data, loading: false });
      })
      .catch(error => console.error("Error fetching data:", error));

    fetch("/api/v1/portal/customers/all/for-dropdown-menu", {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ customers: data });
      })
      .catch(error => console.error("Error fetching data:", error));
  }

  postInvoicesToXeroCustomer = () => {
    this.setState({ processing: true });

    fetch("/api/v1/portal/send-invoices", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    })
      .then(response => response.json())
      .then((data) => {
        // If API returns updated invoices, merge/update them
        // Otherwise, just stop processing and keep current invoices
        if (Array.isArray(data) && data.length > 0) {
          this.setState({ xeroInvoices: data, loading: false });
        }
        setTimeout(() => {
          this.setState({ processing: false });
        }, 5000);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        this.setState({ processing: false });
      });
  }


  render() {

    const { xeroInvoices, customers, loading } = this.state;

    if (loading) {
      return <p>Loading Invoices...</p>;
    }

    const customerName = id => {
      const customer = customers.find(customer => customer.id === id);
      return customer ? customer.name : "";
    };

    return (
      <div id="xero-invoices">
        {xeroInvoices.length > 0 ? (
        <div className="approved-customers-table-container" style={{ marginBottom: "90px" }}>
          {xeroInvoices.reduce((customers, xeroInvoice) => {
            const customer = customers.find(customer => customer.customer_id === xeroInvoice.customer_id);
            if (!customer) {
              customers.push({
                customer_id: xeroInvoice.customer_id,
                customer_name: customerName(xeroInvoice.customer_id),
                invoices: [xeroInvoice]
              });
            } else {
              customer.invoices.push(xeroInvoice);
            }
            return customers;
          }, []).map(customer => (
            <div key={customer.customer_id} className="customers-table">
              <h3 className="text-left"><strong>{customer.customer_name}</strong></h3>
              <div className={"customers-table-customer-row"}>
                <div className={"customers-table-header-row row"}>
                  <div className="col-md-1">Job Id</div>
                  <div className="col-md-1">Qty Order</div>
                  <div className="col-md-1">Net Amount</div>
                  <div className="col-md-2">Service Amount</div>
                  <div className="col-md-4">Service Text</div>
                  <div className="col-md-1">Tax Amount</div>
                  <div className="col-md-1">Tax Code</div>
                  <div className="col-md-1">Invoice Status</div>
                </div>
                <div>
                  {customer.invoices.map(invoice => (
                    <div key={invoice.id} className={"row customer-row-header"}>
                      <div className="col-md-1">{invoice.job_id}</div>
                      <div className="col-md-1">{invoice.qty_order}</div>
                      <div className="col-md-1">{invoice.net_amount}</div>
                      <div className="col-md-2">{invoice.service_amount}</div>
                      <div className="col-md-4">{invoice.service_text}</div>
                      <div className="col-md-1">{invoice.tax_amount}</div>
                      <div className="col-md-1">{invoice.tax_code}</div>
                      <div className="col-md-1">{invoice.invoice_status}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <button
            className="btn btn-primary"
            style={{ marginTop: "20px" }}
            onClick={this.postInvoicesToXeroCustomer}
            disabled={this.state.processing}
          >Approve
          </button>&nbsp;&nbsp;
          <button
            className="btn btn-primary"
            style={{ marginTop: "20px" }}
            onClick={() => {
              document.querySelector("#xero-invoices").style.display = "none";
            }}
          >Close
          </button>
          {this.state.processing && (
            <div style={{ marginTop: "10px", color: "blue" }}>
              Processing...
            </div>
          )}
        </div>
        ) : (
          <div><h2>No Invoices Found</h2></div>
        ) }
      </div>
    );
  }
}


